<script setup>
import { computed, inject } from 'vue'
import { result } from 'lodash-es'
import { format } from 'date-fns'
const props = defineProps({
  edit: Boolean,
  sch: {
    type: Array,
    default: () => [],
  },
  isch: {
    type: Object,
    default: () => ({}),
  },
  name: String,
})
defineEmits(['refresh'])
const model = defineModel()
const complaint = inject('complaint')
const uploads = computed(() => {
  const n = props.name
  if (!n) {
    return []
  }
  return complaint.value.uploads?.filter(u => u?.division == `complaint.${n}`)
})
const stepInfo = computed(() => {
  const mv = model.value
  const sch = props.sch // schema
  const isch = props.isch // plain-text representation schema overridings

  let df = arr => {
    let a1 = {}
    for (const e of arr || []) {
      let [tag, mkey, label, props, ...children] = e // eslint-disable-line no-unused-vars

      let fn = dtf

      if (mkey instanceof Function) {
        fn = mkey
      } else if (Array.isArray(mkey)) {
        ;[mkey, fn] = mkey
      }

      if (label instanceof Function) {
        label = label(mv)
      }

      if (label) {
        a1[mkey] = [label, fn(mv, e) || '—', mkey]
      }

      if (Array.isArray(children) && children.length) {
        a1 = { ...a1, ...df(children) }
      }
    }
    return a1
  }
  let res = df(fillsch(sch, isch))

  for (let [k, v] of Object.entries(isch)) {
    if (res[k]) {
      continue
    }
    let [tag, mkey, label] = v // eslint-disable-line no-unused-vars
    if (label instanceof Function) {
      label = label(mv)
    }
    if (!label) {
      continue
    }

    let fn = mkey instanceof Function ? mkey : dtf
    res[k] = [label, fn(mv, v) || '—', mkey]
  }

  const status = Object.keys(res).length > 0
  return status ? res : null
})

function dtf(mv, [tag, mkey]) {
  let r = result(mv, mkey)
  if (!r) {
    return
  }
  if (tag == 'datepicker') {
    r = format(r, 'dd.MM.y')
  }
  if (tag == 'checkbox') {
    if (r === true) {
      r = 'Да'
    }
    if (r === false) {
      r = 'Нет'
    }
  }
  return r
}

function fillsch(formSchema, readonlySchema) {
  let result = []
  for (const schemaField of formSchema) {
    let [tag, name, label, props, ...children] = schemaField // eslint-disable-line no-unused-vars
    let newField = [...schemaField]
    let roSchemaField = readonlySchema[name]
    if (name && roSchemaField) {
      if (roSchemaField[1] && roSchemaField[1] instanceof Function) {
        roSchemaField[1] = [name, roSchemaField[1]]
      }
      newField = [...roSchemaField, ...newField.slice(roSchemaField.length)]
    }
    if (Array.isArray(children) && children.length) {
      newField = [...newField.slice(0, 4), ...fillsch(children, readonlySchema)]
    }
    result.push(newField)
  }
  return result
}
</script>
<style scoped>
dd {
  margin-bottom: 0;
}
</style>
<template>
  <template v-if="edit">
    <slot />
  </template>
  <div v-else class="readonly">
    <template v-if="stepInfo">
      <dl class="grid gap-1 column-gap-2" style="--bs-columns: 2">
        <template v-for="(v, k) of stepInfo" :key="k">
          <dt>{{ v[0] }}</dt>
          <dd v-if="Array.isArray(v[1])" v-html="v[1].join('')" />
          <dd v-else>{{ v[1] }}</dd>
        </template>
      </dl>
    </template>
    <template v-else-if="$slots.plain">
      <slot name="plain" />
    </template>
    <template v-else>
      <h6>Этап не заполнен</h6>
    </template>
    <template v-if="uploads?.length">
      <dl class="grid gap-1 column-gap-2" style="--bs-columns: 2">
        <dt>Приложены файлы</dt>
        <dd>
          <template v-for="v of uploads" :key="v.secure_filename">
            <a
              class="d-block"
              :href="`/api/v1.0/download/${v.secure_filename}`"
              :download="v.filename"
              >{{ v.filename }}</a
            >
          </template>
        </dd>
      </dl>
    </template>
  </div>
</template>
